import React, { useEffect } from "react";
import CustomerTab from "../Customers/CustomerTab";
import useCustomerView from "../../hooks/useCustomerView";
import CustomerFilters from "../Customers/CustomerFilters";

const CustomerView = () => {
  const { operator, companyId, onOrgTreeChange } = useCustomerView();

  useEffect(onOrgTreeChange, [operator, companyId]);

  return (
    <div className="flex-stretch gs-flex-container-vertical height-100">
      <CustomerFilters />
      <div className="mt-1 flex-stretch gs-flex-container-vertical height-100">
        <CustomerTab />
      </div>
    </div>
  );
};

export default CustomerView;
